/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Date field representation.
 */
export interface DateClaimValue {
    /** The date field value in RFC 3339 format. */
    value: string;
}
